<template>
	<section class="page page-test">
		<!-- <ChalkyPadTable />
		<ChalkyPadBallTray /> -->

		<!-- <nav>
			<button class="size-x-small" v-on:click="Handle_OnClickShowMenu">Menu</button>
		</nav> -->

		<!-- <ChalkyUtilityModal ref="controls" v-if="showMenu">
			<div class="controls">
				<button class="size-x-small" v-on:click="Handle_OnClickCameraOverview">Overview</button>
				<button class="size-x-small" v-on:click="Handle_OnClickCameraFirstPerson">First Person</button>

				<button class="size-x-small" v-on:click="Handle_OnClickRackBalls($event, 'EightBall')">
					Rack Balls
				</button>
				<button class="size-x-small" v-on:click="Handle_OnClickShuffle($event)">Shuffle</button>
				<button class="size-x-small" v-on:click="Handle_OnClickUndo($event)">Undo</button>
				<button class="size-x-small" v-on:click="Handle_OnClickFullscreen($event)">Fullscreen</button>
				<button class="size-x-small" v-on:click="Handle_OnClickJump($event)">Jump</button>
				<button class="size-x-small" v-on:click="Handle_OnClickCamera($event)">Camera</button>
				<button class="size-x-small" v-on:click="Handle_OnClickUpload($event)">Upload</button>
				<button class="size-x-small" v-on:click="Handle_OnClickFps($event)">FPS</button>
				<button class="size-x-small" v-on:click="Handle_OnClickAimLines($event)">Aim Lines</button>
			</div>
		</ChalkyUtilityModal> -->

		<!-- <ChalkyTrainerSceneGame
			v-bind:debugMode="false"
			v-bind:showEnglishMeter="false"
			v-bind:showFpsCounter="false"
			v-bind:showPowerMeter="true"
		/> -->

		<!-- <SceneTableDetector /> -->

		<!-- <ChalkyUtilityCamera
			ref="camera"
			v-if="showCamera"
			v-bind:autoStart="true"
			v-bind:facingMode="'environment'"
			v-bind:isFullscreen="true"
			v-bind:showMenu="true"
			v-on:capture="Handle_OnCameraCapture"
			v-on:close="Handle_OnCameraClose"
		/>

		<input accept="image/*" ref="fileInput" style="display: none" type="file" v-on:change="processImageFromFile" /> -->

		<ViewPadCombo />

		<!-- <ViewPadCreator /> -->

		<!-- <ViewTrainerDiagram /> -->
	</section>
</template>

<script lang="ts">
	import ChalkySticks from '@chalkysticks/sdk';
	import PageBase from '@/Core/Page.vue';
	import { Component, Ref } from 'vue-property-decorator';

	/**
	 * Teachable Machine Webcam Classifier Component
	 *
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package Page
	 * @project ChalkySticks App
	 */
	@Component
	export default class PageTest extends PageBase {
		/**
		 * @type boolean
		 */
		protected showCamera: boolean = false;

		/**
		 * @type boolean
		 */
		protected showMenu: boolean = false;

		/**
		 * Process an image from file input
		 *
		 * @param Event e - File input change event
		 * @return Promise<void>
		 */
		public async processImageFromFile(e: Event): Promise<void> {
			const input = e.target as HTMLInputElement;

			if (!input.files || input.files.length === 0) {
				return;
			}

			const file = input.files[0];

			// Check if it's an image file
			if (file.type.startsWith('image/')) {
				console.log('🎱 Processing dropped image:', file.name);

				// Analyze the image and rack the balls
				ChalkySticks.Core.Event.Bus.dispatch('game.control:rackAnalyze', file);
			} else {
				console.warn('⚠️ Dropped file is not an image:', file.type);
			}

			// Reset file input so the same file can be selected again
			input.value = '';
		}

		/**
		 * Wait longer than the blink!!!!
		 *
		 * @param PointerEvent e
		 * @return Promise<void>
		 */
		protected async Handle_OnCameraCapture(e: {
			blob: Blob;
			canvas: HTMLCanvasElement;
			dataUrl: string;
		}): Promise<void> {
			// console.log('sup', e.dataUrl);
			ChalkySticks.Core.Event.Bus.dispatch('game.control:rackAnalyze', e.blob);

			this.showCamera = false;
		}

		/**
		 * @param PointerEvent e
		 * @return Promise<void>
		 */
		protected async Handle_OnCameraClose(e: any): Promise<void> {
			this.showCamera = false;
		}

		/**
		 * @param PointerEvent e
		 * @return Promise<void>
		 */
		protected async Handle_OnClickCamera(e: PointerEvent): Promise<void> {
			e.preventDefault();

			// Open user camera and get photo
			// @ts-ignore
			// this.$refs.fileInput.click();

			// @ts-ignore
			// const blob = await this.$refs.camera.capture();
			// const file = new File([blob], 'photo.jpg', { type: 'image/jpeg' });

			// Convert blob to file
			this.showCamera = true;

			// ChalkySticks.Core.Event.Bus.dispatch('game.control:rackAnalyze', file);
			// console.log('result', blob);
		}

		/**
		 * @param PointerEvent e
		 * @return Promise<void>
		 */
		protected async Handle_OnClickUpload(e: PointerEvent): Promise<void> {
			e.preventDefault();

			// Open user camera and get photo
			// @ts-ignore
			this.$refs.fileInput.click();
		}

		/**
		 * @param PointerEvent e
		 * @return Promise<void>
		 */
		protected async Handle_OnClickCameraFirstPerson(e: PointerEvent): Promise<void> {
			e.preventDefault();

			ChalkySticks.Core.Event.Bus.dispatch('camera:set:first-person', {
				animate: true,
			});
		}

		/**
		 * @param PointerEvent e
		 * @return Promise<void>
		 */
		protected async Handle_OnClickCameraOverview(e: PointerEvent): Promise<void> {
			e.preventDefault();

			ChalkySticks.Core.Event.Bus.dispatch('camera:set:preset', {
				animate: true,
				preset: 'overview',
			});
		}

		/**
		 * @param PointerEvent e
		 * @return Promise<void>
		 */
		protected async Handle_OnClickAimLines(e: PointerEvent): Promise<void> {
			e.preventDefault();

			ChalkySticks.Core.Event.Bus.dispatch('game.control:toggleGuides');
		}

		/**
		 * @param PointerEvent e
		 * @return Promise<void>
		 */
		protected async Handle_OnClickFps(e: PointerEvent): Promise<void> {
			e.preventDefault();

			ChalkySticks.Core.Event.Bus.dispatch('game.control:toggleFpsCounter');
		}

		/**
		 * @param PointerEvent e
		 * @return Promise<void>
		 */
		protected async Handle_OnClickJump(e: PointerEvent): Promise<void> {
			e.preventDefault();

			ChalkySticks.Core.Event.Bus.dispatch('game.control:jump', 1.5);
		}

		/**
		 * @param PointerEvent e
		 * @return Promise<void>
		 */
		protected async Handle_OnClickFullscreen(e: PointerEvent): Promise<void> {
			e.preventDefault();

			// Toggle fullscreen
			if (document.fullscreenElement) {
				// Exit fullscreen
				if (document.exitFullscreen) {
					await document.exitFullscreen();
				}
			} else if (document.fullscreenEnabled) {
				// Enter fullscreen
				await document.documentElement.requestFullscreen();
			}
		}

		/**
		 * @param PointerEvent e
		 * @param Enum.RackStrategy strategy
		 * @return Promise<void>
		 */
		protected async Handle_OnClickRackBalls(e: PointerEvent, strategy: string): Promise<void> {
			e.preventDefault();

			ChalkySticks.Core.Event.Bus.dispatch('game.control:rack', strategy);
		}

		/**
		 * @param PointerEvent e
		 * @return Promise<void>
		 */
		protected async Handle_OnClickShowMenu(e: PointerEvent): Promise<void> {
			e.preventDefault();

			this.showMenu = !this.showMenu;
		}

		/**
		 * @param PointerEvent e
		 * @return Promise<void>
		 */
		protected async Handle_OnClickShuffle(e: PointerEvent): Promise<void> {
			e.preventDefault();

			ChalkySticks.Core.Event.Bus.dispatch('game.control:shuffle');
		}

		/**
		 * @param PointerEvent e
		 * @return Promise<void>
		 */
		protected async Handle_OnClickUndo(e: PointerEvent): Promise<void> {
			e.preventDefault();

			ChalkySticks.Core.Event.Bus.dispatch('game.control:undo');
		}
	}
</script>

<style lang="scss">
	.page-test {
		height: 100dvh;

		nav {
			display: flex;
			flex-direction: column;
			gap: 1rem;
			height: 100%;
			justify-content: flex-end;
			left: 0;
			padding: 1rem;
			position: absolute;
			z-index: 999;
		}

		// .controls {
		// 	display: grid;
		// 	gap: 1rem;
		// 	grid-template-columns: repeat(3, 1fr);
		// 	margin-top: 2rem;
		// 	max-width: 50%;
		// 	padding: 1rem;
		// }
		//
		// .view-camera {
		// 	height: 100%;
		// 	left: 0;
		// 	position: absolute;
		// 	top: 0;
		// 	width: 100%;
		// 	z-index: 10;
		// }
	}

	// Media Queries
	// ---------------------------------------------------------------------------

	@media screen and (max-height: 600px) {
		#app[page='PageTest'] #GlobalHeader {
			display: none;
		}
	}
</style>
